import { render, staticRenderFns } from "./UnBlockAccountModal.vue?vue&type=template&id=6533b251&"
import script from "./UnBlockAccountModal.vue?vue&type=script&lang=js&"
export * from "./UnBlockAccountModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports